import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SiteSettingsDto } from "@system-shared/classes.dto";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private readonly url = environment.apiUrl + 'settings';
  private readonly systemUrl = environment.apiUrl + 'system';

  constructor(private readonly http: HttpClient) {}

  getSiteSettings(): Observable<SiteSettingsDto[]> {
    return this.http.get<SiteSettingsDto[]>(this.url, { withCredentials: true });
  }

  saveSiteSettings(settings: SiteSettingsDto[]): Observable<SiteSettingsDto[]> {
    return this.http.post<SiteSettingsDto[]>(this.url, settings, { withCredentials: true });
  }

  devReset() {
    return this.http.get(this.systemUrl + '/npm/run/devreset', { withCredentials: true, responseType: "text" });
  }

  migrate() {
    return this.http.get(this.systemUrl + '/npm/run/migrate', { withCredentials: true, responseType: "text" });
  }
}
